import {
  TSUNAMI_EVENT_DATA_DELETE_TSUNAMI_EVENT_REQUEST,
  TSUNAMI_EVENT_DATA_VALIDITY_REQUEST,
  TSUNAMI_EVENT_DATA_CAUSE_REQUEST,
  TSUNAMI_DATA_CLEAR,
  TSUNAMI_EVENT_DATA_REGION_REQUEST,
  TSUNAMI_EVENT_DATA_RUNUP_REGION_REQUEST,
  TSUNAMI_EVENT_DATA_RUNUP_MEASURE_TYPE_REQUEST,
  TSUNAMI_DATA_TOGGLE_COLUMN,
  TSUNAMI_EVENT_DATA_BULK_EDIT_REQUEST,
  TSUNAMI_EVENT_DATA_SAVE_CANCEL_CONFIRMATION,
  TSUNAMI_EVENT_DATA_SAVE_OPEN_CONFIRMATION,
  TSUNAMI_EVENT_DATA_CANCEL_EDIT,
  TSUNAMI_EVENT_DATA_EDIT,
} from './tsunamiEventDataReducer';
import { TSUNAMI_EVENT_DATA_SORT } from '../search/tsunamiEventSearchReducer';


export const clearTsunamiData = () => ({ type: TSUNAMI_DATA_CLEAR });
export const deleteTsunami = ({ id, history }) => ({ type: TSUNAMI_EVENT_DATA_DELETE_TSUNAMI_EVENT_REQUEST, id, history });
export const getValidity = ({ history }) => ({ type: TSUNAMI_EVENT_DATA_VALIDITY_REQUEST, history });
export const getCauses = ({ history }) => ({ type: TSUNAMI_EVENT_DATA_CAUSE_REQUEST, history });
export const getRunupMeasurementTypes = ({ history }) => ({ type: TSUNAMI_EVENT_DATA_RUNUP_MEASURE_TYPE_REQUEST, history });
export const getRegions = ({ history }) => ({ type: TSUNAMI_EVENT_DATA_REGION_REQUEST, history });
export const getRunupRegions = ({ history }) => ({ type: TSUNAMI_EVENT_DATA_RUNUP_REGION_REQUEST, history });
export const sortData = sort => ({ type: TSUNAMI_EVENT_DATA_SORT, sort });
export const toggleColumns = visibleColumns => ({ type: TSUNAMI_DATA_TOGGLE_COLUMN, visibleColumns });
export const bulkEditTsunamis = ({ data }) => ({ type: TSUNAMI_EVENT_DATA_BULK_EDIT_REQUEST, data });
export const openEditConfirmation = ({ formData, initialFormData }) => ({ type: TSUNAMI_EVENT_DATA_SAVE_OPEN_CONFIRMATION, formData, initialFormData });
export const cancelEditConfirmation = () => ({ type: TSUNAMI_EVENT_DATA_SAVE_CANCEL_CONFIRMATION });
export const startEdit = ({ initialValues }) => ({ type: TSUNAMI_EVENT_DATA_EDIT, initialValues });
export const cancelEdit = () => ({ type: TSUNAMI_EVENT_DATA_CANCEL_EDIT });
